const FinishModal = () => {
  return (
    <div className="fixed z-50 top-0 w-screen h-screen text-center align-middle py-96 text-5xl md:text-9xl font-extrabold bg-white bg-opacity-70">
      終了！
    </div>
  );
};

export default FinishModal;
